<header class="background-header classic-background"></header>
<section class="main-side-nav" id="mainSideNav"
	[ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default'}"
	*ngIf="showAllUsers == true">
	<section class="container admin-dashboard-parent accounts-container">
		<section class="template-section-title">
			<div class="breadcrumb-container">
				<span>Admin <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'Mail Log'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
				<h1>Mail Log</h1>
			</div>
		</section>
		<!-- Search -->
		<section class="all-users-line-presentation">
			<div class="search-section">
				<div class="accounts-number">
					<span>
						<!-- {{users.length}} --> Mail Log
					</span>
				</div>
				<div class="buttons-managment">
					<input type="text" class="dashboard-input" placeholder="Last Name" [(ngModel)]="searchData">
					<input type="button" class="btn btn-primary search-btn" value="Search"
						(click)="searchByLastName(searchData)">
					<input type="button" class="btn btn-primary export-btn" value="Export" (click)="exportAsXLSX()">
				</div>
			</div>
		</section>

		<!-- Table of data sought-->
		<section *ngIf="isSearching == true" class="data-sought-container">
			<app-loader *ngIf="!dataIsLoaded"></app-loader>
			<section class="all-users-data" *ngIf="usersFound">
				<div class="table-responsive admin-dashboard-table">
					<table class="table table-borderless table-hover">
						<thead>
							<tr>
								<th scope="col">User Name</th>
								<th scope="col">Email</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let userFound of usersFoundArray" (click)="onSelect(userFound)">
								<td><span>{{userFound.firstName + " " + userFound.lastName}}</span></td>
								<td>{{userFound.email}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>
			<div *ngIf="usersFound == false">
				<div class="not-found-message">{{message}}</div>
			</div>
			<input *ngIf="dataIsLoaded" type="button" class="btn btn-primary back-table" value="Back"
				(click)="backToTable()">
		</section>

		<!-- Table of data not sought-->
		<section class="all-users-data" *ngIf="isSearching == false">
			<div class="table-responsive admin-dashboard-table">
				<table class="table table-borderless table-hover">
					<thead>
						<tr>
							<th scope="col">User Name</th>
							<th scope="col">Email</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let dataUser of users" (click)="onSelect(dataUser)">
							<td><span *ngIf="dataUser.firstName || dataUser.lastName">{{dataUser.firstName + " " +
									dataUser.lastName}}</span></td>
							<td>{{dataUser.email}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>
	</section>
</section>
<app-mail-log-details *ngIf="userDetail == true" [dataUser]="selectedUser" (onClick)="backFromDetailUser()"
	(userOutputValue)="displayUserData($event)"></app-mail-log-details>